import { render, staticRenderFns } from "./Sidebar1.vue?vue&type=template&id=4fa9ce94&scoped=true&"
import script from "./Sidebar1.vue?vue&type=script&lang=js&"
export * from "./Sidebar1.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar1.vue?vue&type=style&index=0&id=4fa9ce94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa9ce94",
  null
  
)

/* custom blocks */
import block0 from "./Sidebar1.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports